import "./bootstrap/bootstrap"

//plugins
import Alpine from "alpinejs"
window.Alpine = Alpine

// shido plugins
import dimentions from "../../../node_modules/shido.dimentions.js/src/dimentions.js"
import forms from "../../../node_modules/shido.forms.js/src/forms.js"
import proportional from "../../../node_modules/shido.proportional.js/src/proportional.js"
import regular from "../../../node_modules/shido.regular.js/src/regular.js"

// app
// require('../../../node_modules/...')
import alert from "./components/alerts"
import { mobile } from "./components/nav"
import SmoothScroll from "../../../node_modules/smooth-scroll/dist/smooth-scroll"
import {
  insuranceSlider,
  insuranceSliderCom,
  insuranceSliderDen,
  insuranceSliderRef
} from "./components/sliders"

// Initializers
const docReady = () => {
  Alpine.start()
  new dimentions().init()
  new forms().init()
  new proportional().init()
  new alert().session()
  new regular().init()

  const scroll = new SmoothScroll('a[href*="#"]', {
    offset: 160
  })

  mobile()
}

const winLoad = () => {}

const docReadyWinload = () => {
  // ...
}

// ---
// [IMPORTANT] Do not change or add anything!
document.addEventListener(
  "DOMContentLoaded",
  () => {
    docReady()
    docReadyWinload()
  },
  false
)
window.addEventListener(
  "load",
  () => {
    winLoad()
    docReadyWinload()
  },
  false
)
// ---
// ---
